export type TableColumnsMessages = {
  optionsColumn: string;
  rowsPerPage: string;
};

export const TABLE_COLUMNS_MESSAGES: TableColumnsMessages = {
  optionsColumn: "Opções",
  rowsPerPage: "Itens por página",
};
